// TODO: From App New
/**
 * Rupiah formatting utilities
 */

/**
 * Format number to Rupiah format with thousand separators
 * @param {number|string} value - The value to format
 * @returns {string} Formatted string (e.g., "1.000.000")
 */
export function formatRupiah(value) {
  if (!value && value !== 0) return ''

  // Convert to string and remove any existing formatting
  const numStr = value.toString().replace(/\D/g, '')

  // Add thousand separators
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

/**
 * Parse formatted Rupiah string back to number
 * @param {string|number} value - The formatted value to parse
 * @returns {number} Parsed number
 */
export function parseRupiahValue(value) {
  if (!value && value !== 0) return 0

  // Remove all non-digit characters and convert to number
  const numStr = value.toString().replace(/\D/g, '')
  return parseInt(numStr, 10) || 0
}

/**
 * Format number to full Rupiah format with "Rp" prefix
 * @param {number|string} value - The value to format
 * @returns {string} Formatted string (e.g., "Rp 1.000.000")
 */
export function formatFullRupiah(value) {
  const formatted = formatRupiah(value)
  return formatted ? `Rp ${formatted}` : ''
}

/**
 * Keypress event handler to allow only digits
 * @param {Event} event - The keypress event
 */
export function handleRupiahKeyPress(event) {
  // Only allow digits
  const charCode = event.which ? event.which : event.keyCode
  if (charCode < 48 || charCode > 57) {
    event.preventDefault()
  }
}

/**
 * Format number to compact Rupiah format (K, M, B)
 * @param {number|string} value - The value to format
 * @returns {string} Compact formatted string (e.g., "1.2M")
 */
export function formatCompactRupiah(value) {
  const num = parseRupiahValue(value)

  if (num >= 1000000000) {
    return `${(num / 1000000000).toFixed(1)}B`
  }
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`
  }

  return formatRupiah(num)
}
